// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2TNYf","filesListContainer":"PosDisputesFiles_filesListContainer__3YnUE","filesButton":"PosDisputesFiles_filesButton__3Zdpg"};